export default "__VITE_ASSET__ec627596__"